import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../common/Icons';
import { HEAD_DOCTOR_COPY } from '../headDoctorCopy';
import { fmtSynthesisNumber } from '../reports/synthesisTableModel';

const H = HEAD_DOCTOR_COPY.DASHBOARD;
const COPY = HEAD_DOCTOR_COPY.REPORTS;

const TONE_ICONS = {
  indigo: 'stethoscope',
  amber: 'alertCircle',
  teal: 'heart',
  violet: 'chartBar',
  slate: 'calendar'
};

export default function DashboardActivityPanel({
  groups = [],
  days = 1,
  periodLabel = '',
  loading = false
}) {
  const maxTotal = Math.max(
    ...groups.flatMap((g) => g.rows.filter((r) => !r.indent).map((r) => Number(r.total || 0))),
    1
  );

  return (
    <section className="hd-dash-activity mb-4" aria-label={H.ACTIVITY_TITLE}>
      <div className="hd-dash-activity__head">
        <div>
          <h2 className="hd-dash-activity__title">{H.ACTIVITY_TITLE}</h2>
          <p className="hd-dash-activity__desc mb-0">{H.ACTIVITY_DESC(days, periodLabel)}</p>
        </div>
        <span className="hd-dash-activity__days">{Number(days || 0).toLocaleString('fr-FR')} j</span>
      </div>

      {loading ? (
        <div className="hd-dash-activity__loading">
          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden />
          {COPY.LOADING}
        </div>
      ) : groups.length === 0 ? (
        <div className="hd-dash-activity__loading">Aucune donnée sur la période.</div>
      ) : (
        <div className="hd-dash-activity__grid">
          {groups.map((group) => {
            const topRows = group.rows.filter((r) => !r.indent);
            const detailRows = group.rows.filter((r) => r.indent);
            return (
              <article
                key={group.section}
                className={`hd-dash-activity-card hd-dash-activity-card--${group.tone}`}
              >
                <header className="hd-dash-activity-card__head">
                  <span className="hd-dash-activity-card__icon" aria-hidden>
                    <Icon name={TONE_ICONS[group.tone] || 'chartBar'} size={16} />
                  </span>
                  <h3 className="hd-dash-activity-card__title">{group.section}</h3>
                </header>

                <ul className="hd-dash-activity-card__list">
                  {topRows.map((row) => {
                    const pct = Math.round((Number(row.total || 0) / maxTotal) * 100);
                    return (
                      <li key={row.key} className="hd-dash-activity-card__row">
                        <div className="hd-dash-activity-card__row-main">
                          {row.link ? (
                            <Link to={row.link} className="hd-dash-activity-card__label">
                              {row.label}
                            </Link>
                          ) : (
                            <span className="hd-dash-activity-card__label">{row.label}</span>
                          )}
                          <div className="hd-dash-activity-card__nums">
                            <strong>{fmtSynthesisNumber(row.total)}</strong>
                            <span>{row.avg}/j</span>
                          </div>
                        </div>
                        <div className="hd-dash-activity-card__track" aria-hidden>
                          <span
                            className="hd-dash-activity-card__fill"
                            style={{ width: `${Math.max(pct, Number(row.total) > 0 ? 4 : 0)}%` }}
                          />
                        </div>
                      </li>
                    );
                  })}
                </ul>

                {detailRows.length > 0 ? (
                  <div className="hd-dash-activity-card__chips">
                    {detailRows.map((row) => (
                      <span
                        key={row.key}
                        className={`hd-dash-activity-chip${Number(row.total) > 0 ? ' has-value' : ''}`}
                      >
                        <span className="hd-dash-activity-chip__label">{row.label}</span>
                        <strong>{fmtSynthesisNumber(row.total)}</strong>
                      </span>
                    ))}
                  </div>
                ) : null}
              </article>
            );
          })}
        </div>
      )}
    </section>
  );
}
